import { Row } from "@/components";

type BaseModalFooterProps = {
  className?: string;
  children: React.ReactNode;
};

export const BaseModalFooter = ({
  children,
  className,
}: BaseModalFooterProps) => {
  return (
    <Row
      as={"footer"}
      bg={"white"}
      alignItems={"center"}
      px={"x36"}
      py={"x8"}
      className={`min-h-x72 w-full br-b-x4 ${className ? className : ""} `}
    >
      {children}
    </Row>
  );
};
